import React from 'react';
import { useModal } from './hooks';

const AppModal = WrappedComponent => {
  const WithModal = ({ modalId, ...props }) => {
    const [showModal, modalData, onCloseModal] = useModal(modalId);

    return (
      showModal && (
        <WrappedComponent
          {...props}
          showModal={showModal}
          onCloseModal={onCloseModal}
          modalData={modalData}
        />
      )
    );
  };

  return WithModal;
};

export default AppModal;
